import React, { FC, useEffect, useState } from "react";

import { Box, Typography, Card, CardContent, Link } from "@components/base";

interface RecommendationDetailDescription {
  title: string;
  description: string;
}

const RecommendationDetailDescription: FC<RecommendationDetailDescription> = ({
  title,
  description,
}) => {
  const shortDescriptionMaxLength = 420;
  const [shortDescription, setShortDescription] = useState("");
  const [showMore, setShowMore] = useState(false);

  const handleShowMore = (): void => {
    setShowMore(!showMore);
  };

  useEffect(() => {
    const tmp = document.createElement("DIV");

    tmp.innerHTML = description;

    const _shortDescription = tmp.textContent || tmp.innerText || "";

    setShortDescription(_shortDescription);
  }, [description]);

  return (
    <Card>
      <CardContent>
        <Typography variant="h5" fontWeight={500}>
          {title}
        </Typography>
        <Box mt={2}>
          <Typography
            variant="body2"
            sx={{
              "& div": {
                overflow: showMore ? "auto" : "hidden",
                height: showMore ? undefined : 116,
                textOverflow: "ellipsis",
                display: "inline-block",
              },
            }}
          >
            {showMore ? (
              <div dangerouslySetInnerHTML={{ __html: description }}></div>
            ) : shortDescription.length > shortDescriptionMaxLength ? (
              `${shortDescription.slice(0, shortDescriptionMaxLength)}...`
            ) : (
              shortDescription
            )}
          </Typography>
          <Link
            component="button"
            onClick={handleShowMore}
            color="textPrimary"
            fontSize={14}
          >
            {showMore ? "Show less" : "Show more"}
          </Link>
        </Box>
      </CardContent>
    </Card>
  );
};

export default RecommendationDetailDescription;
